module.exports = __webpack_public_path__ + "img/okayama.90fc6419.png";